var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _vm.$userInfo.isSupportUser ||
    _vm.$userInfo.isCustomerAdministrator ||
    _vm.$userInfo.isSystemAdministrator
      ? _c("div", { staticClass: "tile is-parent pl-1" }, [
          _c("article", { staticClass: "tile is-child box" }, [
            _c(
              "div",
              { staticClass: "columns is-flex is-align-items-center" },
              [
                _vm._m(0),
                !_vm.hasError &&
                _vm.showSavingStatus &&
                !_vm.toastNotificationEnabled
                  ? _c(
                      "div",
                      {
                        staticClass:
                          "column is-flex is-justify-content-flex-end is-align-items-center",
                      },
                      [
                        _vm.saving
                          ? _c("span", {
                              staticClass: "button is-loading is-white",
                              staticStyle: { height: "27px" },
                            })
                          : _c(
                              "span",
                              { staticClass: "text has-text-success" },
                              [
                                _c("span", { staticClass: "mso mso-18px" }, [
                                  _vm._v("check_circle"),
                                ]),
                              ]
                            ),
                        _c(
                          "span",
                          {
                            staticClass: "is-size-6",
                            class: _vm.saving
                              ? "has-text-warning"
                              : "has-text-success",
                          },
                          [_vm._v(_vm._s(_vm.savingStatus))]
                        ),
                      ]
                    )
                  : _vm._e(),
              ]
            ),
            _c("div", { staticClass: "field columns" }, [
              _c("div", { staticClass: "column is-half" }, [
                _c("label", { staticClass: "label" }, [_vm._v("Max Users")]),
                _c("div", { staticClass: "control" }, [
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model.number",
                        value: _vm.companyLicense.maxUsers,
                        expression: "companyLicense.maxUsers",
                        modifiers: { number: true },
                      },
                    ],
                    staticClass: "input",
                    attrs: {
                      type: "number",
                      disabled: !_vm.$userInfo.isSystemAccount,
                    },
                    domProps: { value: _vm.companyLicense.maxUsers },
                    on: {
                      blur: [
                        function ($event) {
                          return _vm.$v.companyLicense.maxUsers.$touch()
                        },
                        function ($event) {
                          return _vm.$forceUpdate()
                        },
                      ],
                      input: function ($event) {
                        if ($event.target.composing) return
                        _vm.$set(
                          _vm.companyLicense,
                          "maxUsers",
                          _vm._n($event.target.value)
                        )
                      },
                    },
                  }),
                  _vm.$v.companyLicense.maxUsers.$dirty &&
                  !_vm.$v.companyLicense.maxUsers.required
                    ? _c("span", { staticClass: "help is-danger" }, [
                        _vm._v("Max User required "),
                      ])
                    : _vm._e(),
                  _vm.$v.companyLicense.maxUsers.$dirty &&
                  !_vm.$v.companyLicense.maxUsers.maxValueValue
                    ? _c("span", { staticClass: "help is-danger" }, [
                        _vm._v("Max number 100 "),
                      ])
                    : _vm._e(),
                ]),
              ]),
              _c("div", { staticClass: "column is-half" }, [
                _c("label", { staticClass: "label" }, [
                  _vm._v("Concurrent Users"),
                ]),
                _c("div", { staticClass: "control" }, [
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model.number",
                        value: _vm.companyLicense.concurrentUsers,
                        expression: "companyLicense.concurrentUsers",
                        modifiers: { number: true },
                      },
                    ],
                    staticClass: "input",
                    attrs: {
                      type: "number",
                      disabled: !_vm.$userInfo.isSystemAccount,
                    },
                    domProps: { value: _vm.companyLicense.concurrentUsers },
                    on: {
                      blur: [
                        function ($event) {
                          return _vm.$v.companyLicense.concurrentUsers.$touch()
                        },
                        function ($event) {
                          return _vm.$forceUpdate()
                        },
                      ],
                      input: function ($event) {
                        if ($event.target.composing) return
                        _vm.$set(
                          _vm.companyLicense,
                          "concurrentUsers",
                          _vm._n($event.target.value)
                        )
                      },
                    },
                  }),
                  _vm.$v.companyLicense.concurrentUsers.$dirty &&
                  !_vm.$v.companyLicense.concurrentUsers.required
                    ? _c("span", { staticClass: "help is-danger" }, [
                        _vm._v("Concurrent User required "),
                      ])
                    : _vm._e(),
                  _vm.$v.companyLicense.concurrentUsers.$dirty &&
                  !_vm.$v.companyLicense.concurrentUsers.maxValueValue
                    ? _c("span", { staticClass: "help is-danger" }, [
                        _vm._v("Max number 100 "),
                      ])
                    : _vm._e(),
                ]),
              ]),
            ]),
            _c("div", { staticClass: "field columns" }, [
              _c("div", { staticClass: "column is-half" }, [
                _c("label", { staticClass: "label" }, [_vm._v("License Type")]),
                _c("div", { staticClass: "control is-fullwidth" }, [
                  _c("span", { staticClass: "select is-fullwidth" }, [
                    _c(
                      "select",
                      {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.companyLicense.licenseType,
                            expression: "companyLicense.licenseType",
                          },
                        ],
                        attrs: { disabled: !_vm.$userInfo.isSystemAccount },
                        on: {
                          change: function ($event) {
                            var $$selectedVal = Array.prototype.filter
                              .call($event.target.options, function (o) {
                                return o.selected
                              })
                              .map(function (o) {
                                var val = "_value" in o ? o._value : o.value
                                return val
                              })
                            _vm.$set(
                              _vm.companyLicense,
                              "licenseType",
                              $event.target.multiple
                                ? $$selectedVal
                                : $$selectedVal[0]
                            )
                          },
                        },
                      },
                      _vm._l(
                        _vm.companyLicenseTypes,
                        function (type, typeIndex) {
                          return _c(
                            "option",
                            { key: typeIndex, domProps: { value: type } },
                            [_vm._v(" " + _vm._s(type) + " ")]
                          )
                        }
                      ),
                      0
                    ),
                  ]),
                ]),
              ]),
              _c(
                "div",
                { staticClass: "column is-half" },
                [
                  _c("label", { staticClass: "label" }, [
                    _vm._v("Expire Date"),
                  ]),
                  _c("v-date-picker", {
                    staticClass: "is-fullwidth",
                    attrs: {
                      "is-dark": _vm.$theme.isDark,
                      masks: _vm.formats,
                      attributes: _vm.attrs,
                      locale: _vm.$userInfo.locale,
                    },
                    on: { input: _vm.expireDateInputEvent },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function ({ inputValue, inputEvents }) {
                            return [
                              _c("div", { staticClass: "field has-addons" }, [
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "control is-expanded has-icons-left",
                                  },
                                  [
                                    _c(
                                      "input",
                                      _vm._g(
                                        {
                                          staticClass: "input",
                                          attrs: {
                                            type: "text",
                                            placeholder: "Expiry date",
                                            disabled:
                                              !_vm.$userInfo.isSystemAccount,
                                          },
                                          domProps: { value: inputValue },
                                        },
                                        inputEvents
                                      )
                                    ),
                                    _c(
                                      "span",
                                      { staticClass: "icon is-small is-left" },
                                      [
                                        _c(
                                          "span",
                                          { staticClass: "mso mso-18px" },
                                          [_vm._v("calendar_month")]
                                        ),
                                      ]
                                    ),
                                  ]
                                ),
                              ]),
                            ]
                          },
                        },
                      ],
                      null,
                      false,
                      587075840
                    ),
                    model: {
                      value: _vm.companyLicense.expiryDate,
                      callback: function ($$v) {
                        _vm.$set(_vm.companyLicense, "expiryDate", $$v)
                      },
                      expression: "companyLicense.expiryDate",
                    },
                  }),
                ],
                1
              ),
            ]),
          ]),
        ])
      : _c("div", { staticClass: "is-flex is-justify-content-center pt-5" }, [
          _c(
            "div",
            {
              staticClass:
                "notification is-danger is-flex is-justify-content-center is-size-4",
              staticStyle: { width: "50%" },
            },
            [_vm._v(" You do not have permissions on this page ")]
          ),
        ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "column" }, [
      _c("p", { staticClass: "title" }, [_vm._v("License")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }